import script from "./OfferGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferGroup.vue?vue&type=script&setup=true&lang=js"

import "./OfferGroup.vue?vue&type=style&index=0&id=7f54daf6&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f54daf6"]])

export default __exports__